import { useEffect } from 'react';
import { useHistory } from 'react-router-dom';

export const useResetScroll = (resetCallback = () => window.scrollTo(0, 0)) => {
  const history = useHistory();
  const { pathname } = history.location;
  useEffect(() => {
    resetCallback();
  }, [pathname]);
};
